<template>
    <form @submit.prevent="submit" data-id="loginForm" novalidate="novalidate">
        <span class="p-mb-3 p-field p-col-12 p-d-block p-d-no-padding">
            <label
                data-id="loginForm-label-name"
                for="login"
                v-t="'label.login'"
            ></label>
            <InputText
                id="login"
                v-model="login"
                type="text"
                data-id="loginForm-input-name"
                autocomplete="username"
                :class="{ invalid: errors.login.length }"
            />
            <div class="input-error-container">
                <small v-if="errors.login.length" class="input-error" v-t="'errors.login.' + errors.login" />
            </div>
        </span>
        <span class="p-mb-0 p-field p-col-12 p-d-block p-d-no-padding">
            <label
                data-id="loginForm-label-password"
                for="password"
                v-t="'label.password'"
            ></label>
            <InputText
                ref="passwordField"
                id="password"
                v-model="password"
                type="password"
                data-id="loginForm-input-password"
                autocomplete="current-password"
                :class="{ invalid: errors.password.length }"
            />
            <div class="input-error-container p-mb-5">
                <small v-if="errors.password.length" class="input-error" v-t="'errors.password.' + errors.password" />
            </div>
        </span>
        <router-link
            :to="{ name: 'forgotPassword' }"
            data-id="loginForm-forgotPassword"
            class="forgot-password"
            v-t="'forgotPassword'"
        />
        <Button
            type="submit"
            class="p-button"
            :label="$t('button.submit')"
            data-id="loginForm-button-submit"
        ></Button>
    </form>
</template>

<script>
    import InputText from 'primevue/inputtext';
    import Button from 'primevue/button';
    import isValidEmail from "myra-ui-common/utils/isValidEmail";
    import encodePassword from "myra-ui-common/utils/encodePassword";

    export default {
        name       : 'LogIn',
        components : {
            Button,
            InputText,
        },
        data() {
            return {
                login    : '',
                password : '',
                errors   : {
                    login    : '',
                    password : '',
                }
            };
        },
        watch : {
            login() {
                this.errors.login = '';
            },
            password() {
                this.errors.password = '';
            }
        },
        methods : {
            isFormValid() {
                let isValid = true;
                if (this.login.length < 1) {
                    this.errors.login = 'empty';
                    isValid = false;
                } else if (!isValidEmail(this.login)) {
                    this.errors.login = 'invalidEmail';
                    isValid = false;
                }
                if (this.password.length < 1) {
                    this.errors.password = 'empty';
                    isValid = false;
                }
                return isValid;
            },
            submit() {
                if (!this.isFormValid()) {
                    return;
                }
                const data = {
                    username : this.login,
                    password : encodePassword(this.password),
                };
                this.$emit('submit', 'login', data, 'home');
            },
        },
    };
</script>

<i18n src="myra-ui-common/i18n/common.json" />
<i18n src="./i18n.json" />
